import Auth from '@getgo/auth-client'
import _module from 'module.js'
/**
 * @ngdoc service
 * @name platformApp.api
 * @description
 * # jiveOAuthClient
 * Factory in the platformApp.
 */

const LMI_OAUTH_SETTINGS = {
  prod: {
    oauthUrl: 'https://authentication.logmeininc.com',
    callbackUrl: 'https://my.jive.com/pbx',
    clientID: '2a320c18-8778-4eff-9b62-b1b5235c0c48',
    clientSecret: 'cSx08kY28Up3sS1b6bspSNYY', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  hvoice: {
    oauthUrl: 'https://authentication.logmeininc.com',
    callbackUrl: 'https://my.hvoice.net/pbx',
    clientID: '5cd45d58-e0ad-42ad-86ee-03ad913b8f42',
    clientSecret: 't3pHzcMwutPWbEnef4zkd7IJ', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  staging: {
    oauthUrl: 'https://authenticationstage.logmeininc.com',
    callbackUrl: 'https://my.staging.jive.com/pbx',
    clientID: 'a417e54a-da08-47f5-a911-ca5830e981a9',
    clientSecret: '6rBEbYiEiCbj2jPtW6bL5tqn', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  feature: {
    oauthUrl: 'https://authenticationed1.col.test.expertcity.com',
    callbackUrl: `${window.location.origin}`,
    clientID: 'a0c84a0b-f653-45de-9c4b-c44073725ccc',
    clientSecret: 'yxxrRg3OkiAdcaFdixXpFQx9', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  dev: {
    oauthUrl: 'https://authenticationed1.col.test.expertcity.com',
    callbackUrl: 'https://my.dev.jive.com/pbx',
    clientID: 'a0c84a0b-f653-45de-9c4b-c44073725ccc',
    clientSecret: 'yxxrRg3OkiAdcaFdixXpFQx9', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  devHvoice: {
    oauthUrl: 'https://authenticationed1.col.test.expertcity.com',
    callbackUrl: 'https://my.dev.hvoice.net/pbx',
    clientID: 'a0c84a0b-f653-45de-9c4b-c44073725ccc',
    clientSecret: 'yxxrRg3OkiAdcaFdixXpFQx9', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  local2dev: {
    oauthUrl: 'https://authenticationed1.col.test.expertcity.com',
    callbackUrl: 'http://localhost:9000/pbx',
    clientID: 'a0c84a0b-f653-45de-9c4b-c44073725ccc',
    clientSecret: 'yxxrRg3OkiAdcaFdixXpFQx9', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  },
  local: {  //local portal pointing to production backend
    oauthUrl: 'https://authentication.logmeininc.com',
    callbackUrl: 'http://localhost:9000/pbx',
    clientID: '2a320c18-8778-4eff-9b62-b1b5235c0c48',
    clientSecret: 'cSx08kY28Up3sS1b6bspSNYY', // // this is not a real secret, see https://logmein.slack.com/archives/CSC9G7A56/p1761059170753849?thread_ts=1761058148.747849&cid=CSC9G7A56
  }
}

export const LMI_ADMIN_PORTAL_TOKEN = 'lmi-admin-portal-token'

const CODE_VERIFIER_KEY = 'pkce_code_verifier'
const STATE_KEY = 'pkce_state'
const INFLIGHT_REQUEST_KEY = 'inflight_request'
const HIJACKING_ERROR = 'hijacking'

const populateSession = (auth) => {
  const state = auth.randomString(32)
  const codeVerifier = auth.randomString(64)

  sessionStorage.setItem(STATE_KEY, state)
  sessionStorage.setItem(CODE_VERIFIER_KEY, codeVerifier)

  const currentPath = window.location.pathname + window.location.search + window.location.hash
  sessionStorage.setItem(INFLIGHT_REQUEST_KEY, currentPath)

  return { state, codeVerifier }
}

const clearSession = () => {
  sessionStorage.removeItem(STATE_KEY)
  sessionStorage.removeItem(CODE_VERIFIER_KEY)
  sessionStorage.removeItem(INFLIGHT_REQUEST_KEY)
}

const createLMIOAuthClient = ($location) => {
  const environment = getEnvironment($location)
  const { clientID, oauthUrl, callbackUrl, clientSecret } = LMI_OAUTH_SETTINGS[environment]

  const options = {
    client_id: clientID,
    url: oauthUrl,
    redirect_url: callbackUrl,
    enableTokenRefresh: true,
  }

  const auth = new Auth(options)

  const getStoredSessionValues = () => ({
    state: sessionStorage.getItem(STATE_KEY),
    codeVerifier: sessionStorage.getItem(CODE_VERIFIER_KEY),
    inflightRequest: sessionStorage.getItem(INFLIGHT_REQUEST_KEY),
  })

  const validateState = (returnedState, storedState) => {
    if (returnedState !== storedState) {
      console.error(HIJACKING_ERROR)
      clearSession()
      throw new Error('State mismatch')
    }
  }

  const exchangeCodeForToken = async (authCode, returnedState, codeVerifier) => {
    try {
      const tokenResponse = await auth.requestPKCEToken({
        state: returnedState,
        code: authCode,
        code_verifier: codeVerifier,
        client_secret: clientSecret,
      })
      return tokenResponse
    } catch (error) {
      console.error('[AUTH] Error getting token:', error)
      clearSession()
      throw error
    }
  }

  const storeTokenAndCleanup = (tokenData) => {
    sessionStorage.setItem(LMI_ADMIN_PORTAL_TOKEN, JSON.stringify(tokenData))
    localStorage.setItem(LMI_ADMIN_PORTAL_TOKEN, JSON.stringify(tokenData)) // for backward compatibility
    clearSession()

    const cleanUrl = tokenData.inflightRequest || window.location.pathname
    window.history.replaceState({}, document.title, cleanUrl)
  }

  const handleOAuthCallback = async (authCode, returnedState) => {
    const { state, codeVerifier, inflightRequest } = getStoredSessionValues()

    validateState(returnedState, state)

    const tokenResponse = await exchangeCodeForToken(authCode, returnedState, codeVerifier)
    const tokenData = {
      token: tokenResponse.access_token,
      jiveId: tokenResponse.principal,
      expires: tokenResponse.expires,
      inflightRequest,
      type: tokenResponse.token_type || 'Bearer',
    }

    storeTokenAndCleanup(tokenData)

    return tokenData
  }

  const getStoredToken = () => {
    const tokenString = sessionStorage.getItem(LMI_ADMIN_PORTAL_TOKEN)
    if (!tokenString) return null

    const token = JSON.parse(tokenString)
    delete token.inflightRequest
    return token
  }

  const initiateLogin = () => {
    const { state, codeVerifier } = populateSession(auth)
    try {
      auth.loginWithPKCE({
        state,
        code_verifier: codeVerifier
      })
    } catch (error) {
      console.error('[AUTH] Error getting authorization code:', error)
      throw error
    }
    return false
  }

  /*
    There are three possible scenarios:
    1. User is returning from OAuth server to the callback URL with the auth code, so we can exchange it for a token
    2. Existing token found in sessionStorage, which can be used
    3. No token found, so we must initiate the login process
  */
  const getAuthToken = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const authCode = urlParams.get('code')
    const returnedState = urlParams.get('state')

    // Scenario 1: OAuth callback (user returning from OAuth server, code and state in the URL params)
    const isCallback = !!(authCode && returnedState)
    if (isCallback) {
      return handleOAuthCallback(authCode, returnedState)
    }

    // Scenario 2: Check for existing token
    const existingToken = getStoredToken()
    if (existingToken) {
      return existingToken
    }

    // Scenario 3: No token found, initiate the login process
    return initiateLogin()
  }

  const getAuthInfo = ({ inflightRequest }, cb) => {
    getAuthToken({ inflightRequest })
      .then((token) => token && cb(null, token))
      .catch((err) => cb(err))
  }

  const logout = () => {
    clearAuthInfo()
    auth.logout()
  }

  const clearAuthInfo = () => {
    sessionStorage.removeItem(LMI_ADMIN_PORTAL_TOKEN)
    localStorage.removeItem(LMI_ADMIN_PORTAL_TOKEN)
  }

  return {
    auth: {
      getAuthInfo,
      logout,
      clearAuthInfo
    }
  }
}

const getEnvironment = ($location) => {
  const host = $location.host().toLowerCase();
  let env = 'prod'
  if (host.includes('my.staging')) {
    env = 'staging'
  } else if (host.includes('my.dev.hvoice')) {
    env = 'devhvoice'
  } else if (host.includes('my.dev')) {
    env = 'dev'
  } else if (host.includes('my.hvoice')) {
    env = 'hvoice'
  } else if (host.includes('localhost')) {
    env = window.environment === 'dev' ? 'local2dev' : 'local'
  } else if (window.environment == 'feature') {
    env = 'feature'
  }
  return env
}

_module.factory('jiveOAuthClient', createLMIOAuthClient)
